import { PaymentItem } from '@modules/CartPage/components/ProductsList/components/Payment/CardItemTemplate';

export const additionalPaymentMethods: PaymentItem[] = [
    { paymentSystem: 'NEW_CARD', name: 'Новая карта', withoutCard: true },
    { paymentSystem: 'QR', name: 'СБП', withoutCard: true },
];

export const paymentSystems = ['VISA', 'MASTER_CARD', 'MAESTRO', 'MIR', 'UNION_PAY', 'UNKNOWN'];
